import type { JackpotType, JackpotVariant } from '../../types';
import { JackpotInfo } from '../JackpotInfo/JackpotInfo';

type JackpotLayoutType = 'overdrive' | 'bonanza' | 'rapidfire';
type LayoutConfig = {
  wrapper: string;
  grid: string;
  highlight: string;
};

type JackpotProps = {
  jackpots: JackpotType[];
  variant: JackpotVariant;
  layout: JackpotLayoutType;
};

function Jackpots({ jackpots, variant, layout }: JackpotProps) {
  const JACKPOT_LAYOUTS = {
    overdrive: {
      default: {
        wrapper: 'w-full md:w-auto md:mx-auto',
        grid: 'grid grid-cols-1 gap-y-6 content-stretch items-center xs:grid-cols-2 xs:gap-x-3 md:grid-cols-[repeat(3,auto)]',
        highlight: 'row-span-1 row-start-1 col-span-full md:col-span-1 md:col-start-2',
      },
      sticky: {
        wrapper: 'w-full',
        grid: 'grid grid-cols-1 gap-y-6 content-stretch items-center xs:grid-cols-2 xs:gap-x-3 lg:grid-cols-[repeat(3,auto)]',
        highlight: 'row-span-1 row-start-1 col-span-full lg:col-span-1 lg:col-start-2',
      },
    },
    bonanza: {
      default: {
        wrapper: 'w-full md:w-auto md:mx-auto',
        grid: 'grid grid-cols-1 gap-y-6 content-stretch items-center xs:grid-cols-3 xs:gap-x-3 md:grid-cols-[repeat(4,auto)]',
        highlight: 'row-span-1 row-start-1 col-span-full md:col-span-1 md:col-start-1',
      },
      sticky: {
        wrapper: 'w-full',
        grid: 'grid grid-cols-1 gap-y-6 content-stretch items-center xs:grid-cols-3 xs:gap-x-3 lg:grid-cols-[repeat(4,auto)]',
        highlight: 'row-span-1 row-start-1 col-span-full lg:col-span-1 lg:col-start-1',
      },
    },
    rapidfire: {
      default: {
        wrapper: 'w-full md:w-auto md:mx-auto',
        grid: 'grid grid-cols-1 gap-y-6 content-stretch items-center md:grid-cols-5 md:gap-x-3',
        highlight: 'row-span-1 row-start-1 col-span-full md:col-span-1 md:col-start-3',
      },
      sticky: {
        wrapper: 'w-full',
        grid: 'grid grid-cols-1 gap-y-6 content-stretch items-center lg:grid-cols-5 lg:gap-x-3',
        highlight: 'row-span-1 row-start-1 col-span-full lg:col-span-1 lg:col-start-3',
      },
    },
  } satisfies Record<JackpotLayoutType, Record<JackpotVariant, LayoutConfig>>;

  const classes = JACKPOT_LAYOUTS[layout][variant];

  return (
    <div className={classes.wrapper}>
      <div className={classes.grid}>
        {jackpots.map(({ label, icon, value, previousValue, refreshInterval, highlight, variant }: JackpotType) => (
          <JackpotInfo
            key={label}
            variant={variant}
            icon={icon}
            label={label}
            value={value}
            previousValue={previousValue}
            refreshInterval={refreshInterval}
            highlight={highlight}
            className={highlight ? classes.highlight : undefined}
          />
        ))}
      </div>
    </div>
  );
}

export { Jackpots };
